export default {
  LIST_FETCHED: 'TRANSFER_REQUESTS_FETCHED',
  LIST_LOAD: 'TRANSFER_REQUESTS_LOAD',
  ITEM_DETAIL: 'TRANSFER_REQUESTS_DETAIL',
  BUTTON_LOAD: 'TRANSFER_REQUESTS_BUTTON_LOAD',
};
